import _ from "underscore";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";
import BasicUtils from "../../utils/basic-utils";
import { actions } from "../../utils/overlay-store";

// Use this if you want to control a modal's open/close state
// through a prop. Would be useful if you want to close a modal
// when a component is unmounted etc.
export default class extends React.Component {
  static displayName = "ModalState";

  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  componentDidMount() {
    if (this.props.isOpen) {
      return this.handleLaunchModal();
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.isOpen && !this.props.isOpen) {
      return this.handleLaunchModal();
    } else if (!newProps.isOpen && this.props.isOpen) {
      return actions.removeModal();
    }
  }

  componentWillUnmount() {
    return actions.removeModal();
  }

  handleLaunchModal = () => {
    const child = React.Children.only(this.props.children);
    const dialog = React.cloneElement(child, {
      onClose: this.handleRemove,
      onUnmount: this.handleRemove,
    });

    actions.launchModal(dialog);
    return typeof this.props.onClick === "function" ? this.props.onClick() : undefined;
  };

  handleRemove = () => {
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
    return actions.removeModal();
  };

  render() {
    return null;
  }
}
